<template>
  <v-dialog v-model="splashDialog" persistent width="500" @keydown.esc="closePage">
    <v-card :outlined="true" :raised="true">
      <v-card-title primary-title class="mb-4 pt-10">
        Data in ICT PLUS
      </v-card-title>

      <v-card-text class="body-1 mb-4 pb-2">
        <p><b>Please be mindful that data in ICT PLUS is updated at different intervals.</b> The update intervals are based on the nature/availability of access to each data source. Visit the "Data Sources" tab in our <b><a href="#/help-and-support" style="text-decoration:none">Help & Support</a></b> page for more information.</p>
        <p>ICT PLUS sources data from multiple existing systems. If the data in ICT PLUS doesn't line up to what you've found in your school, let us know via the "Feedback" button and we'll escalate your concern to the relevant system owners.</p>
      </v-card-text>

      <v-card-actions class="pt-0 pr-6 pb-6">
        <v-spacer/>
        <v-btn depressed color="primary darken-1" @click.native="closePage" class="text-none" style="width: 120px; height: 50px; font-size: 16px; font-weight: bold;">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapActions} from "vuex";

  export default {
    name: "SplashPage",
    data: () => ({
      splashDialog: false,
    }),
    methods: {
      ...mapActions(['refreshToken','removeToken']),
      open() {
        this.splashDialog = true;
      },
      isOpened() {
        return this.splashDialog === true;
      },
      async closePage() {
        this.splashDialog = false;
        sessionStorage.setItem('ictp-splash-page-status', 'read');
      }
    }
  }
</script>

<style scoped>
  .v-card__text{
    color: black !important;
  }
</style>
